// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';

//Main action with API
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const FETCH_RESET = 'fetch_reset';
export const CHANGE_LOADING_STATE = 'change_loading_state';
export const CLEAR_IS_USER_CHECK = 'clear_is_user_check';

export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

//Auth const
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const USER_TOKEN_SET = 'user_token_set';

// User info
export const USER_DATA = 'user_data';
export const USER_DATA_SUCCESS = 'user_data_success';
export const USER_DATA_FAIL = 'user_data_fail';
export const GET_LIST_VAI_TRO = 'get_list_vai_tro';
export const GET_LIST_VAI_TRO_SUCCESS = 'get_list_vai_tro_success';
export const GET_LIST_VAI_TRO_FAIL = 'get_list_vai_tro_fail';

// User Action
export const NEW_USER_SERVER_IS = 'NEW_USER_SERVER_IS';
export const NEW_USER_SERVER_IS_SUCCESS = 'NEW_USER_SERVER_IS_SUCCESS';
export const NEW_USER_SERVER_IS_FAIL = 'NEW_USER_SERVER_IS_FAIL';

export const NEW_NGUOI_DUNG = 'NEW_NGUOI_DUNG';
export const NEW_NGUOI_DUNG_SUCCESS = 'NEW_NGUOI_DUNG_SUCCESS';
export const NEW_NGUOI_DUNG_FAIL = 'NEW_NGUOI_DUNG_FAIL';

export const DELETE_NGUOI_DUNG = 'DELETE_NGUOI_DUNG';
export const DELETE_NGUOI_DUNG_SUCCESS = 'DELETE_NGUOI_DUNG_SUCCESS';
export const DELETE_NGUOI_DUNG_FAIL = 'DELETE_NGUOI_DUNG_FAIL';

// Danh mục dùng chung
export const GET_LIST_HUYEN = 'GET_LIST_HUYEN';
export const GET_LIST_XA = 'GET_LIST_XA';
export const GET_LIST_DON_VI_BY_ID = 'GET_LIST_DON_VI_BY_ID';
